// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"f3bc03d9","514":"a2ce106c"}[chunkId] + ".chunk.css";
};